//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AzureActivateStatus, UserService} from '../../../services/user-service';
import {AppUpdateService} from '../../../services/app-update.service';
import {UntilDestroy} from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-azure-activate',
    templateUrl: './azure-activate.component.html',
    styleUrls: ['./azure-activate.component.scss'],
    standalone: false
})
export class AzureActivateComponent implements OnInit {
  private azureActivationToken: string;

  message = '';
  error = '';
  activated = false;
  loginUrl = '';
  showLogin = true;

  constructor(private userService: UserService,
              private route: ActivatedRoute,
              private appUpdateService: AppUpdateService) {
      this.appUpdateService.checkForUpdate();
      this.loginUrl = '/login';
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if ( this.azureActivationToken == null ) {
          this.azureActivationToken = params?.['token'];
      }
    });
  }

  activateWhenLoggedIn($event) {
      this.showLogin = false;
      this.userService.azureMarketActivate(this.azureActivationToken, $event.id_token)
        .subscribe({
          next: result => {

            if (result.status != AzureActivateStatus.SUCCESS) {
              this.message = 'azure.activate.errors.error-occurred';
            }

            switch (result.status) {

              case AzureActivateStatus.SUCCESS:
                this.message = 'azure.activate.activated';
                this.error = '';
                this.activated = true;
                break;

              case AzureActivateStatus.NOT_ACCEPTABLE:
                this.error = 'azure.activate.errors.not-acceptable';
                break;

              case AzureActivateStatus.TENANT_ID:
                this.error = 'azure.activate.errors.tenant-id';
                break;

            }
          }
        });
  }
}
